<template>
  <div class=" fa">
    <div class="err1">请求getSHA256WithRSA try {{ err1 }}</div>
    <div class="err2" style="background-color:rgb(200, 0, 255)">
      getSHA256WithRSA加密的数据 {{ `${str}` }}
    </div>
    <div class="err2" style="background-color:orange">
      getSHA256WithRSA 返回result <span>{{ result1 }}</span>
    </div>
    <div class="err2">
      请求的wxjsdata <span>{{ wxjsdata }}</span>
    </div>
    <div class="err2" style="background-color:greenyellow">
      WeixinJSBridge<span>{{ WeixinJSBridgedata }}</span>
    </div>
    <div class="err2">
      调起wxjspay try
      <span>
        {{ err2 }}
      </span>
    </div>
    <div class="err2" style="background-color:rgb(0, 128, 255)">
      调起wxjspay返回 <span>{{ result2 }}</span>
    </div>

    <el-input v-model="packages"> </el-input>
    <el-button @click="wxJsPay"> 点击测试wx js支付 </el-button>
  </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script>
// const axios = require("axios");
import { paySubmit, getSHA256WithRSA } from "@/api/index.js";
export default {
  inject: ["reload"],
  data() {
    return {
      err1: "",
      err2: "",
      result1: "",
      result2: "",
      packages: "prepay_id=wx301446144393218ae81768c6b7b7d10000",
      str: "",
      wxjsdata: "",
      WeixinJSBridgedata:""
    };
  },
  async mounted() {},
  beforeMount() {
    var resolution = window.screen.height * window.screen.width;
    // this.img_height=180*(resolution/(864*1536));
    // this.div_style="width:"+ 200+"px;height:"+this.img_height+"px"
    if (resolution <= 700 * 900) {
      this.personZhuce_box_class = "person-zhuce-box-small";
    }
    if (resolution > 700 * 900 && resolution < 1400 * 900) {
      this.personZhuce_box_class = "person-zhuce-box-middle ";
    }
    if (resolution > 1400 * 900) {
      this.personZhuce_box_class = "person-zhuce-box-large ";
    }
  },
  beforeDestroy() {
    console.log("personZhuce销毁前的狗子");
    clearInterval(this.timer);
  },
  methods: {
    async wxJsPay() {
      var timeStamp = new Date().valueOf();
      var noncestr = this.getKey(32, 62);
      var packages = this.packages;
      /* let str =
        "wxf3f47ae2feec7a78\n" +
        timeStamp +
        "\n" +
        noncestr +
        "\n" +
        packages +
        "\n";
      this.str = str;
      try {
        var result1 = await getSHA256WithRSA(str);
        this.result1 = result1;
      } catch (err1) {
        this.err1 = err1;
      } */

      try {
        const wxjsdata = {
          appId: "wxf003ddc051b4643b", //公众号ID，由商户传入
          timeStamp: timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: noncestr, //随机串
          package: packages,
          signType: "RSA", //微信签名方式：
          paySign:
            "rAZpuaaPu5FIExjtvOQ520cAm2lBP+PeU4RYnYxBzn/QDsVii37cCIjKSROSB1jop+juSZMhWqXRvIa0tJQwI5ZBtxQt6iwERh+NTJi8FOI+oLJdqI31/nbLBoD4k4agL0908xiudjj2Sjt9sMZUiO6Kb22++1X0ogNdcoyA1AFHrDAuX8NrypHlARva3mMYbaxXQGWDSGxquMlUYG0AzVtustfF8CEPpfVT6Yc5k1MyconP47yfgFyCEYn/UDFp+WSzq4fGROx8Q+y1F7GB1Wr4xOfWRZN8Nv0xO4/x/0zA+3E3K8Q1SzdRCNi9oNkYz8CfgnST9gRW+Pmll3NTHg=="
        };
        this.wxjsdata = JSON.stringify(wxjsdata);
        this.WeixinJSBridgedata =window.top.WeixinJSBridgedata;
        window.top.WeixinJSBridge.invoke("getBrandWCPayRequest", wxjsdata, function(res) {
          this.result2 = JSON.stringify(res);
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        });
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      } catch (err2) {
        this.err2 = err2;
      }
    }
  }
};
</script>
<style scoped>
.fa {
  height: 100%;
  /* background: url(../assets/pic/0001.jpg); */
  background-position: center;
  background-attachment: fixed;
  background-size: 105% auto;
}
.err1 {
  display: block;
  width: calc(100vw - 100px);
  margin-left: 50px;
  height: auto;
  min-height: 100px;
  background-color: rgb(198, 198, 198);
}
.err2 {
  display: block;
  color: #fff;
  width: calc(100vw - 100px);
  margin-left: 50px;
  height: auto;
  min-height: 100px;
  background-color: rgb(255, 115, 115);
  word-wrap: break-word;

  word-break: normal;
  padding: 5px;
}
</style>
